function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsistencyReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1432",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-536.685,-785.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ribbon-Border",
    d: "M777.976,1775.02C632.582,1678.31 536.685,1512.98 536.685,1325.43C536.685,1027.63 778.462,785.853 1076.26,785.853C1374.06,785.853 1615.84,1027.63 1615.84,1325.43C1615.84,1512.66 1520.28,1677.74 1375.31,1774.52L1501.35,2113.29C1506.26,2126.49 1497.78,2140.62 1482.42,2144.85L1340.34,2110.68L1248.69,2209.07C1233.32,2213.29 1216.88,2206.01 1211.97,2192.8L1089.95,1864.84C1085.4,1864.95 1080.84,1865.01 1076.26,1865.01C1072.03,1865.01 1067.8,1864.96 1063.59,1864.86L939.279,2199.82C934.366,2213.06 917.926,2220.36 902.559,2216.13L810.904,2117.49L668.83,2151.75C653.463,2147.51 644.989,2133.35 649.903,2120.11L777.976,1775.02Z",
    style: {
      fill: "white",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Inner-Circle",
    cx: 1074.89,
    cy: 1325.52,
    r: 503.155,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right-Tail",
    transform: "matrix(1,0,0,1,4,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.71,1864.27C1195.52,1859.34 1283.88,1829.88 1359.58,1782.13L1477.01,2097.75C1481.46,2109.73 1473.77,2122.55 1459.83,2126.38L1330.91,2095.38L1247.74,2184.66C1233.79,2188.49 1218.87,2181.88 1214.42,2169.9L1100.71,1864.27Z",
    style: {
      fill: "white",
      fillOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Tail",
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.07,1864.33L930.237,2176.43C925.789,2188.41 910.906,2195.02 896.994,2191.19L814.016,2101.89L685.393,2132.9C671.482,2129.07 663.81,2116.25 668.258,2104.26L787.459,1783.08C863.149,1830.48 951.413,1859.62 1046.07,1864.33Z",
    style: {
      fill: "white",
      fillOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M841.622,1333.85C841.622,1333.85 1005.07,1522.79 1007.9,1523.56C1010.72,1524.33 1335.39,1119.14 1335.39,1119.14",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "122.53px"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.12956e-14,1001.03,-1001.03,6.12956e-14,1070.88,822.135)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(25,152,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,208,64)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsistencyReward);
export default __webpack_public_path__ + "static/media/ConsistencyReward.8a28c498408f8f98745b57f0b2bf70c6.svg";
export { ForwardRef as ReactComponent };